export default {
  timingTaskStatus: ['启动', '不启动'],
  status: ['停用', '正常'],
  goodsType: ['物料', '半成品', '成品'],
  checkFlag: ['不检验', '抽检', '全部检验'],
  snFlag: ['不管理', '管理'],
  constituteType: ['1.通用', '2.按分类', '3.按料号'],
  yesNo: ['是', '否'],
  officeType: ['采购商', '供应商'],
  registrationType: ['被邀请', '自行注册'],
  orderType: ['一般采购', '委外采购', 'VMI采购'],
  newOrderType: ['一般订单', '委外订单', 'VMI订单'],
  managementModel: ['生产型', '贸易型', '服务型', '政府或其他机构'],
  businessStatus: ['存续', '在业', '吊销', '注销', '迁入', '迁出', '停业', '清算'],
  printerTimes: ['采购订单', '发货单'],
  judgmentCriteria: ['根据分数', '根据条件'],
  passMark: ['合格', '不合格'],
  defaultAddressSign: ['默认地址', '非默认地址'],
  invoiceClassify: ['纸质发票', '电子发票'],
  invoiceType: ['普通发票', '增值税普通发票', '增值税专用发票'],
  costType: ['入库', '退货', '维修费用', '模具返还', '质量扣款'],
  dataSource: ['erp', 'srm'],
  dataSource1: ['ERP', 'SRM', 'WMS', 'MES'],
  billStatus: ['开立', '已审核', '已确认', '已核对', '已抛转', '已作废'],
  fileType: ['图纸', '文件'],
  docType: ['采购单号', '发货单号', '收货单号', '对账单号', '维修单号', '质量扣款单号', '借出单号', '借出归还单号', '成本项编号', '合同模板编号', '外检申请单号', '生产申报单号', '预约单号', '供应商编号', '临时物料编号', '考核指标编号', '评估体系编号', '评估体系页签编号', '绩效考核单号'],
  encodingStyle: ['年度单据', '月度单据', '日度单据'],
  sendAction: ['确认订单', '新订单', '订单变更', '订单答交', '订单结案', '发货', '取消发货', '收货', '验退', '仓退'],
  reportType: ['普通报表', '标签'],
  reportKind: ['订单', '发货单'],
  publicType: ['默认模板', '指定模板'],
  usingFlag: ['启用', '停用'],
  transferSign: ['已抛转', '未抛转'],
  sex: ['男', '女'],
  positionStatus: ['在职', '离职'],
  inquiryType: ['一般采购', '委外采购', '工艺采购'],
  inquiryStatus: ['待发布', '询价中', '已截止', '已结案', '已撤销'],
  purchaseType: ['单次采购', '协议采购'],
  outDbType: ['T100', 'GP', 'E10', 'YF'],
  srmSettingType: ['机构', '采购中心'],
  result: ['有效', '无效'],
  objectType: ['机构', '采购中心', '供应商', '工厂'],
  invoiceSign: ['已开票', '未开票'],
  diffSign: ['正常数据', '差异数据'],
  scoreOptions: ['公开', '邀请竞价'],
  modeOptions: ['竞买', '竞卖'],
  unReceiveQty: ['大于0', '等于0'],
  isShowMony: ['是', '否']
}
